"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discover = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Discover = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zM4 18V6h16v6c0 3.31-6 6-12 6H4zm5-6a3 3 0 116 0 3 3 0 01-6 0z", clipRule: "evenodd" })); };
exports.Discover = Discover;
//# sourceMappingURL=discover.js.map